import { render } from "./MyPageModal.vue?vue&type=template&id=1978cbc0&scoped=true"
import script from "./MyPageModal.vue?vue&type=script&lang=js"
export * from "./MyPageModal.vue?vue&type=script&lang=js"

import "./MyPageModal.vue?vue&type=style&index=0&id=1978cbc0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1978cbc0"]])

export default __exports__